import React, { ReactNode } from 'react';
import usePermissions from 'src/hooks/usePermissions';
import { PermissionsInterface } from 'src/store/sessionSlice';

interface Props {
  capability: keyof PermissionsInterface;
  children: ReactNode;
}

// Renders children only when the current admin holds the capability.
// UX gating only — the backend enforces the same capability with a 403.
const Can = ({ capability, children }: Props) => {
  const permissions = usePermissions();

  return permissions[capability] ? <>{children}</> : null;
};

export default Can;
